import { createContext, ReactNode } from 'react';

export type Language = { [key: string]: ReactNode | ((...args: any[]) => ReactNode) };

let current: Language = {};

let currentCode: string = '';

export const getLanguageCode = <T extends string>() => currentCode as T;

export const getLanguage = () => ({ ...current });

export const setLanguage = <T extends string>(code: T, language: Language) => {
    currentCode = code;

    current = language;
};

export type IntlContextValue<T extends string> = {
    loading: boolean,
    language: Language,
    current: T | null,
    change: (language: T) => void
};

const IntlContext = createContext({
    loading: true,
    language: {},
    current: 'ptBR',
    change: () => {}
} as IntlContextValue<any>);

IntlContext.displayName = 'IntlContext';

export default IntlContext;
